module.exports = __webpack_public_path__ + "img/img1.5828cc9e.jpg";